var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.811768 1V5.36364M0.811768 1H5.1754M0.811768 1L5.90268 6.09091M0.811768 17V12.6364M0.811768 17H5.1754M0.811768 17L5.90268 11.9091M16.8118 1L12.4481 1M16.8118 1V5.36364M16.8118 1L11.7209 6.09091M16.8118 17H12.4481M16.8118 17V12.6364M16.8118 17L11.7209 11.9091",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalArea);
export default __webpack_public_path__ + "static/media/total-area.7602d4f46750c6e13588a8a6554a2bd4.svg";
export { ForwardRef as ReactComponent };